document.addEventListener('DOMContentLoaded', () => {
  eventsListeners();
  darkMode();

  // Muestra campos condicionales
  const metodoContacto = document.querySelectorAll('input[name="contacto[medio-contacto]"]');
  metodoContacto.forEach((input) => input.addEventListener('click', mostrarMetodosContacto));
});

const darkMode = () => {
  //LEER PREFERENCIAS DEL SISTEMA
  const preferenciaDarkMode = window.matchMedia('(prefers-color-scheme: dark)');
  // console.log(preferenciaDarkMode.matches);
  if(preferenciaDarkMode.matches){
    document.body.classList.add('dark-mode');
  }
  else{
    document.body.classList.remove('dark-mode');   
  }

  preferenciaDarkMode.addEventListener('change', () => {
    if(preferenciaDarkMode.matches){
      document.body.classList.add('dark-mode');
    }
    else{
      document.body.classList.remove('dark-mode');   
    }
  });

  const btnDarkMode = document.querySelector('.dark-mode-boton');
  btnDarkMode.addEventListener('click', toggleDarkMode);
}
const toggleDarkMode = () => {
  document.body.classList.toggle('dark-mode');
}


const eventsListeners = () => {
  const mobileMenu = document.querySelector('.mobile-menu');
  mobileMenu.addEventListener('click', navegacionResponsive);
}
const navegacionResponsive = () => {
  console.log('Desde navegacion responsive');
  const navegacion = document.querySelector('.navegacion');
  navegacion.classList.toggle('mostrar');
}

const mostrarMetodosContacto = (event) =>{
  const contactoDiv = document.querySelector('#contacto'); 
  
  if(event.target.value === 'telefono'){
    contactoDiv.innerHTML = `
      <hr>
      <label for="telefono">Ingresa tu Teléfono</label>
      <input data-cy="input-telefono" type="tel" name="contacto[telefono]" id="telefono" placeholder="Tu teléfono">

      <p>Elija la fecha y la hora para la llamada</p>
      <label for="fecha">Fecha</label>
      <input data-cy="input-fecha" type="date" name="contacto[fecha]" id="fecha">

      <label for="hora">Hora</label>
      <input data-cy="input-hora" type="time" name="contacto[hora]" id="hora" min="09:00" max="18:00">
    `; 
  }
  else{
    contactoDiv.innerHTML = `
      <hr>
      <label for="email">Ingresa tu E-mail</label>
      <input data-cy="input-email" type="email" name="contacto[email]" id="email" placeholder="Tu correo eletrónico" required>
    `; 
  }
} 